import EventsGrid from './EventsGrid';

export default EventsGrid;
